import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AdminUnreadReportStorage } from './upload-documents/admin-unread-reports-storage';
import { UNREAD_REPORTS_STORAGE } from '../documents';

@Component({
    selector: 'admin-level',
    template: '<router-outlet class="flex-router-outlet"></router-outlet>',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        { provide: UNREAD_REPORTS_STORAGE, useExisting: AdminUnreadReportStorage },
    ]
})
export class AdminLevelComponent { }